import React from 'react';
import { useSelector } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import Fade from '@material-ui/core/Fade';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
import { currentViewNameState, userPreferencesState } from './TicketListSlice';
import { userInfoState } from '../HomeSlice';

export default function TicketListRow(props) {
  const { labelId, row, classes, headCells } = props;
  const { t } = useTranslation();

  const currentViewName = useSelector(currentViewNameState);
  const userPreferences = useSelector(userPreferencesState);
  const { filteredColumns } = userPreferences.find(
    (userPreference) => userPreference.viewName === currentViewName,
  );
  const user = useSelector(userInfoState);

  function handleClick(selectedRow) {
    props.handleClick(selectedRow);
  }

  function isColumnVisibleForUser(columnName) {
    if (headCells) {
      const columnProperty = headCells.find((item) => item.id === columnName);
      return (
        user.internal ||
        user.hasEmilyDRights ||
        user.externalMax ||
        columnProperty.mandatory === true
      );
    }
    return true;
  }

  return (
    <TableRow
      className={classes.row}
      hover
      onClick={() => handleClick(row)}
      role="checkbox"
      tabIndex={-1}
    >
      {isColumnVisibleForUser('ticketNumber') && filteredColumns.ticketNumber && (
        <TableCell
          component="th"
          id={labelId}
          className={classes.tableCell}
          scope="row"
        >
          {row.ticketNumber}
        </TableCell>
      )}
      {isColumnVisibleForUser('ticketNumber') && filteredColumns.wagonNumber && (
        <TableCell align="left" className={classes.tableCell}>
          {row.wagonNumber}
        </TableCell>
      )}
      {isColumnVisibleForUser('ticketCreator') &&
        filteredColumns.ticketCreator && (
          <TableCell align="left" className={classes.tableCell}>
            {row.ticketCreator}
          </TableCell>
        )}
      {isColumnVisibleForUser('plannedType') && filteredColumns.plannedType && (
        <TableCell align="left" className={classes.tableCell}>
          {t(row.plannedType)}
        </TableCell>
      )}

      {isColumnVisibleForUser('ticketStatus') && filteredColumns.ticketStatus && (
        <TableCell align="left" className={classes.tableCell}>
          {row.ticketStatus}
        </TableCell>
      )}
      {isColumnVisibleForUser('businessUnit') && filteredColumns.businessUnit && (
        <TableCell align="left" className={classes.tableCell}>
          {row.businessUnit}
        </TableCell>
      )}
      {isColumnVisibleForUser('lastAnomalyDate') &&
        filteredColumns.lastAnomalyDate && (
          <TableCell align="left" className={classes.tableCell}>
            {row.lastAnomalyDate}
          </TableCell>
        )}
      {isColumnVisibleForUser('wagonStatus') && filteredColumns.wagonStatus && (
        <TableCell align="left" className={classes.tableCell}>
          {t(row.wagonStatus)}
        </TableCell>
      )}
      {isColumnVisibleForUser('loadedStatus') && filteredColumns.loadedStatus && (
        <TableCell align="left" className={classes.tableCell}>
          {t(row.loadedStatus)}
        </TableCell>
      )}
      {isColumnVisibleForUser('priority') && filteredColumns.priority && (
        <TableCell align="left" className={classes.tableCell}>
          {row.priority != null ? row.priority : '-'}
        </TableCell>
      )}
      {isColumnVisibleForUser('damageCodes') && filteredColumns.damageCodes && (
        <Tooltip
          TransitionComponent={Fade}
          title={row.damageDescriptions}
          arrow
        >
          <TableCell align="left" className={classes.tableCell}>
            {row.damageCodes}
          </TableCell>
        </Tooltip>
      )}
      {isColumnVisibleForUser('damagePlace') && filteredColumns.damagePlace && (
        <TableCell align="left" className={classes.tableCell}>
          {row.damagePlace}
        </TableCell>
      )}

      {isColumnVisibleForUser('siteConcerned') &&
        filteredColumns.siteConcerned && (
          <TableCell
            align="left"
            className={`${classes.tableCell} ${classes.siteConcerned}`}
          >
            {t(row.siteConcerned)}
          </TableCell>
        )}
      {isColumnVisibleForUser('keeper') && filteredColumns.keeper && (
        <TableCell align="left" className={classes.tableCell}>
          {row.keeper}
        </TableCell>
      )}
      {isColumnVisibleForUser('productType') && filteredColumns.productType && (
        <TableCell align="left" className={classes.tableCell}>
          {row.productType}
        </TableCell>
      )}
      {isColumnVisibleForUser('origin') && filteredColumns.origin && (
        <TableCell align="left" className={classes.tableCell}>
          {row.origin}
        </TableCell>
      )}
      {isColumnVisibleForUser('labelWagon') && filteredColumns.labelWagon && (
        <TableCell align="left" className={classes.tableCell}>
          {row.labelWagon}
        </TableCell>
      )}
      {isColumnVisibleForUser('appliedLabel') && filteredColumns.appliedLabel && (
        <TableCell align="left" className={classes.tableCell}>
          {row.appliedLabel}
        </TableCell>
      )}
      {isColumnVisibleForUser('nextRevisionDate') &&
        filteredColumns.nextRevisionDate && (
          <TableCell align="left" className={classes.tableCell}>
            {row.nextRevisionDate}
          </TableCell>
        )}
      {isColumnVisibleForUser('assignedWorkshop') &&
        filteredColumns.assignedWorkshop && (
          <TableCell align="left" className={classes.tableCell}>
            {row.assignedWorkshop}
          </TableCell>
        )}
    </TableRow>
  );
}
